export default [
  { value: 'FIXED', label: 'TotalPriceForSale' },
  { value: 'BY_SHARE', label: 'PriceForParticipation' },
  { value: 'BY_SOCIETY', label: 'SocietyValuation' },
];
